const wildcardDomain = new RegExp('^\\*(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+[0-9a-zA-Z]$');
export default wildcardDomain;






// WEBPACK FOOTER //
// ./src/common/reg/wildcardDomain.js